import { render } from "./PopUpPreviewQuestionAdmin.vue?vue&type=template&id=53e4443d"
import script from "./PopUpPreviewQuestionAdmin.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewQuestionAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__